var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 6.35294L0.752513 5.7519C0.510519 5.85154 0.351886 6.0866 0.350017 6.3483C0.348147 6.61 0.503407 6.84729 0.743952 6.95038L1 6.35294ZM14 1L14.601 1.24749C14.701 1.00485 14.6452 0.725929 14.4596 0.540381C14.2741 0.354832 13.9952 0.299048 13.7525 0.398959L14 1ZM8.64706 14L8.04961 14.256C8.15271 14.4966 8.39 14.6519 8.6517 14.65C8.9134 14.6481 9.14846 14.4895 9.2481 14.2475L8.64706 14ZM6.35294 8.64706L6.95039 8.39101C6.88464 8.2376 6.7624 8.11536 6.60899 8.04961L6.35294 8.64706ZM1.24749 6.95398L14.2475 1.60104L13.7525 0.398959L0.752513 5.7519L1.24749 6.95398ZM13.399 0.752513L8.04602 13.7525L9.2481 14.2475L14.601 1.24749L13.399 0.752513ZM9.2445 13.744L6.95039 8.39101L5.7555 8.90311L8.04961 14.256L9.2445 13.744ZM6.60899 8.04961L1.25605 5.7555L0.743952 6.95038L6.09689 9.2445L6.60899 8.04961Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.c83b0c9b81f0ed7bb317b3b8351447b8.svg";
export { ForwardRef as ReactComponent };